module.exports = __webpack_public_path__ + "img/down-black.15830c5f.svg";